import { useMutation } from '@tanstack/react-query';

import { postBooking, putProposal } from '../clients/bookings';

const BookingActions = {
  booking: {
    makeBooking(tripData) {
      return postBooking(tripData);
    },
  },
};

export default BookingActions;

export const useUpdateProposalMutation = () => {
  const mutation = useMutation({
    mutationFn: ({
      bookingId,
      preferredCurrency,
    }: {
      bookingId: string;
      preferredCurrency: string;
    }) => putProposal(bookingId, preferredCurrency),
  });
  return mutation;
};
